export default __webpack_public_path__ + "static/media/ocbc-icon.d508e879.svg";